import { Grid, Modal, Typography } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { Company } from "../types";
import styles from "./index.module.scss";

export type ShowInfoOrganizationModalType = {
  open: (company: Company) => void;
  close: () => void;
};

export const ShowInfoOrganizationModal =
  forwardRef<ShowInfoOrganizationModalType>((_, ref) => {
    const { t } = useTranslation();
    const [company, setCompany] = useState<Company | null>(null);
    const [opened, setOpened] = useState<boolean>(false);

    const screens = Grid.useBreakpoint();
    const isMobile = screens.xs === true;

    const open = (company: Company) => {
      setCompany(company);
      setOpened(true);
    };

    const close = () => {
      setOpened(false);
      setCompany(null);
    };

    useImperativeHandle(ref, () => ({
      open: (company: Company) => open(company),
      close: () => close(),
    }));

    return (
      <Modal
        title={
          <Typography.Title level={3}>
            {t("customer_info.title")}
          </Typography.Title>
        }
        open={opened}
        onCancel={close}
        footer={null}
        style={
          isMobile
            ? {
                top: "calc(28px + var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))",
              }
            : {}
        }
        styles={{}}
        className={styles.SignActModal}
      >
        <Typography.Title level={5}>
          {t("customer_info.customer_name")}
        </Typography.Title>
        <Typography.Text>{company?.name}</Typography.Text>
        <Typography.Title level={5}>
          {t("customer_info.customer_inn")}
        </Typography.Title>
        <Typography.Text>{company?.inn}</Typography.Text>
        <Typography.Title level={5}>
          {t("customer_info.customer_address")}
        </Typography.Title>
        <Typography.Text>{company?.address}</Typography.Text>
        <Typography.Title level={5}>
          {t("customer_info.customer_phone")}
        </Typography.Title>
        <Typography.Text>{company?.phone}</Typography.Text>
      </Modal>
    );
  });
